var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vx-card",
    {
      attrs: { title: _vm.id === null ? "Cadastrar Usuário" : "Editar Usuário" }
    },
    [
      _c(
        "vs-tabs",
        { attrs: { color: _vm.colorx } },
        [
          _c(
            "vs-tab",
            { attrs: { label: "Usuário" } },
            [
              _c(
                "validation-observer",
                { ref: "formobserver" },
                [
                  _c(
                    "b-form",
                    {
                      on: {
                        submit: function($event) {
                          $event.preventDefault()
                          return _vm.create($event)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "vx-row mb-6" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full mb-2" },
                          [
                            _c("label", [_vm._v("Pessoa Natural")]),
                            _c(
                              "b-input-group",
                              [
                                _c("b-form-input", {
                                  attrs: { readonly: "" },
                                  model: {
                                    value: _vm.naturalEntity.full_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.naturalEntity,
                                        "full_name",
                                        $$v
                                      )
                                    },
                                    expression: "naturalEntity.full_name"
                                  }
                                }),
                                _c(
                                  "b-input-group-append",
                                  [
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.showNaturalEntitySearchGrid = true
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "SearchIcon" }
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle" },
                                          [_vm._v("Buscar")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.showNaturalEntityCreateForm = true
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "PlusIcon" }
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle" },
                                          [_vm._v("Incluir")]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "b-button",
                                      {
                                        attrs: { variant: "outline-primary" },
                                        on: {
                                          click: function($event) {
                                            _vm.naturalEntity = {}
                                          }
                                        }
                                      },
                                      [
                                        _c("feather-icon", {
                                          staticClass: "mr-50",
                                          attrs: { icon: "XIcon" }
                                        }),
                                        _c(
                                          "span",
                                          { staticClass: "align-middle" },
                                          [_vm._v("Limpar")]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "vx-row mb-6" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: "E-mail",
                                  "label-for": "surname"
                                }
                              },
                              [
                                _c("validation-provider", {
                                  attrs: {
                                    name: "E-mail",
                                    rules: "required|email"
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "default",
                                      fn: function(ref) {
                                        var errors = ref.errors
                                        return [
                                          _c("b-form-input", {
                                            staticClass: "required",
                                            attrs: {
                                              id: "email",
                                              state:
                                                errors.length > 0
                                                  ? false
                                                  : null,
                                              name: "email"
                                            },
                                            model: {
                                              value: _vm.userEmail,
                                              callback: function($$v) {
                                                _vm.userEmail = $$v
                                              },
                                              expression: "userEmail"
                                            }
                                          }),
                                          _c("b-form-invalid-feedback", [
                                            _vm._v(
                                              " " + _vm._s(errors[0]) + " "
                                            )
                                          ])
                                        ]
                                      }
                                    }
                                  ])
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]),
                      _c("div", { staticClass: "vx-row" }, [
                        _c(
                          "div",
                          { staticClass: "vx-col w-full" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-5 float-right",
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.cancel }
                              },
                              [_vm._v(" Cancelar ")]
                            ),
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mt-5 mr-2 float-right",
                                attrs: {
                                  variant: "primary",
                                  disabled: !_vm.validateForm,
                                  type: "submit"
                                }
                              },
                              [_vm._v(" Salvar ")]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm.id !== null
            ? _c("vs-tab", { attrs: { label: "Grupos" } }, [
                _c(
                  "div",
                  {
                    staticClass: "vx-row mb-6",
                    staticStyle: { "padding-top": "30px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c(
                          "div",
                          { staticClass: "flex justify-end" },
                          [
                            _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(255, 255, 255, 0.15)",
                                    expression: "'rgba(255, 255, 255, 0.15)'",
                                    modifiers: { "400": true }
                                  }
                                ],
                                staticClass: "mr-2",
                                attrs: { variant: "primary" },
                                on: {
                                  click: function($event) {
                                    _vm.showModal = true
                                  }
                                }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "PlusIcon" }
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("add")))
                                ])
                              ],
                              1
                            ),
                            _c(
                              "b-button",
                              {
                                staticClass: "float-right",
                                attrs: { variant: "outline-secondary" },
                                on: { click: _vm.cancel }
                              },
                              [
                                _c("feather-icon", {
                                  staticClass: "mr-50",
                                  attrs: { icon: "CornerUpLeftIcon" }
                                }),
                                _c("span", { staticClass: "align-middle" }, [
                                  _vm._v(_vm._s(_vm.$t("back")))
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _c("vs-divider"),
                        _c("Grid", {
                          ref: "grid",
                          attrs: {
                            service: _vm.roleService,
                            route_name: "roles",
                            route_grid_path: _vm.userRolesPath,
                            route_delete_path: _vm.userRolesPath,
                            hide_edit: "true",
                            delegate: {
                              destroy: function() {
                                return _vm.destroyRoleUser
                              }
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e(),
          _vm.id !== null
            ? _c("vs-tab", { attrs: { label: "Logs de acesso" } }, [
                _c(
                  "div",
                  {
                    staticClass: "vx-row mb-6",
                    staticStyle: { "padding-top": "30px" }
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "vx-col w-full" },
                      [
                        _c("Grid", {
                          ref: "accessLogsGrid",
                          attrs: {
                            service: _vm.userService,
                            route_name: "users",
                            route_grid_path: _vm.userAccessLogsPath,
                            hide_actions: "true",
                            order_column: "login_at",
                            direction: "desc",
                            css_formats: {
                              status: function(status, model) {
                                if (status === "success") {
                                  return "badge badge-glow badge-success"
                                } else if (status === "failed") {
                                  return "badge badge-glow badge-danger"
                                } else if (status === "unauthorized") {
                                  return "badge badge-glow badge-warning"
                                }
                                return ""
                              }
                            },
                            column_formats: {
                              status: function(val) {
                                if (val === "success") {
                                  return this$1.$t("last_access.status.success")
                                } else if (val === "failed") {
                                  return this$1.$t("last_access.status.failed")
                                } else if (val === "unauthorized") {
                                  return this$1.$t(
                                    "last_access.status.unauthorized"
                                  )
                                }
                                return val || ""
                              }
                            }
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "gridThead",
                                fn: function() {
                                  return [
                                    _c(
                                      "vs-th",
                                      {
                                        key: "id",
                                        attrs: { "sort-key": "id" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("grid.id")))]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "status",
                                        attrs: { "sort-key": "status" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("grid.status")))]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "ip_address",
                                        attrs: { "sort-key": "ip_address" }
                                      },
                                      [_vm._v(_vm._s(_vm.$t("last_access.ip")))]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "device_type",
                                        attrs: { "sort-key": "device_type" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("last_access.device"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "browser",
                                        attrs: { "sort-key": "browser" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("last_access.browser"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "platform",
                                        attrs: { "sort-key": "platform" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(_vm.$t("last_access.platform"))
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "login_at_formatted",
                                        attrs: { "sort-key": "login_at" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("last_access.date_time")
                                          )
                                        )
                                      ]
                                    ),
                                    _c(
                                      "vs-th",
                                      {
                                        key: "logout_at_formatted",
                                        attrs: { "sort-key": "logout_at" }
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.$t("last_access.logout_at")
                                          )
                                        )
                                      ]
                                    )
                                  ]
                                },
                                proxy: true
                              },
                              {
                                key: "gridData",
                                fn: function(props) {
                                  return _vm._l(props.data, function(
                                    tr,
                                    indextr
                                  ) {
                                    return _c(
                                      "vs-tr",
                                      { key: indextr, attrs: { data: tr } },
                                      [
                                        _c("vs-td", { key: "id" }, [
                                          _c("div", [_vm._v(_vm._s(tr.id))])
                                        ]),
                                        _c("vs-td", { key: "status" }, [
                                          _c(
                                            "div",
                                            {
                                              class: _vm.getStatusBadgeClass(
                                                tr.status
                                              )
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.getStatusLabel(
                                                      tr.status
                                                    )
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]),
                                        _c("vs-td", { key: "ip_address" }, [
                                          _c("div", [
                                            _vm._v(_vm._s(tr.ip_address))
                                          ])
                                        ]),
                                        _c("vs-td", { key: "device_type" }, [
                                          _c("div", [
                                            _vm._v(_vm._s(tr.device_type))
                                          ])
                                        ]),
                                        _c("vs-td", { key: "browser" }, [
                                          _c("div", [
                                            _vm._v(_vm._s(tr.browser))
                                          ])
                                        ]),
                                        _c("vs-td", { key: "platform" }, [
                                          _c("div", [
                                            _vm._v(_vm._s(tr.platform))
                                          ])
                                        ]),
                                        _c(
                                          "vs-td",
                                          { key: "login_at_formatted" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(tr.login_at_formatted)
                                              )
                                            ])
                                          ]
                                        ),
                                        _c(
                                          "vs-td",
                                          { key: "logout_at_formatted" },
                                          [
                                            _c("div", [
                                              _vm._v(
                                                _vm._s(tr.logout_at_formatted)
                                              )
                                            ])
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  })
                                }
                              }
                            ],
                            null,
                            false,
                            397811374
                          )
                        })
                      ],
                      1
                    )
                  ]
                )
              ])
            : _vm._e()
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: { title: "Grupos", active: _vm.showModal },
          on: {
            "update:active": function($event) {
              _vm.showModal = $event
            }
          }
        },
        [
          _vm.showModal
            ? _c("Grid", {
                attrs: {
                  service: _vm.roleService,
                  delegate: {
                    itemSelected: function() {
                      return _vm.itemSelected
                    }
                  },
                  route_name: "/roles",
                  hide_actions: "true"
                }
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: {
            fullscreen: "",
            iconPack: "material-icons",
            title: "Cadastrar Usuário",
            active: _vm.showNaturalEntityCreateForm
          },
          on: {
            "update:active": function($event) {
              _vm.showNaturalEntityCreateForm = $event
            }
          }
        },
        [
          _c("NaturalEntityForm", {
            attrs: {
              services: _vm.services,
              naturalEntityId: null,
              hide_spouse: "true"
            },
            on: { close: _vm.closeNaturalEntityPopup }
          })
        ],
        1
      ),
      _c(
        "vs-popup",
        {
          attrs: {
            title: "Pessoa Natural",
            active: _vm.showNaturalEntitySearchGrid
          },
          on: {
            "update:active": function($event) {
              _vm.showNaturalEntitySearchGrid = $event
            }
          }
        },
        [
          _c("Grid", {
            attrs: {
              service: _vm.services.naturalEntityService,
              route_name: "natural_entities",
              hide_actions: "true",
              delegate: {
                itemSelected: function() {
                  return _vm.naturalEntitySelected
                }
              }
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }